import $ from "jquery";

export const init = () => {
    const $btnOpenSearch = $(".btn--search.btn--header");
    $btnOpenSearch.click(function (e) {
        e.preventDefault();
        $('body').addClass("search-open");
    });

    const $btnCloseSearch = $(".search-close");
    $btnCloseSearch.click(function (e) {
        e.preventDefault();
        $('body').removeClass("search-open");
    });

    let body = document.querySelector('body');
    document.addEventListener("click", (e) => {
        if ((body.classList.contains("search-open") && e.target.closest('#search') == null && e.target.closest('.btn--search') == null) || e.target.classList.contains("search-close")) {
            $('body').removeClass("search-open");
        }
    });
};
